import React from 'react';
import clsx from 'clsx';
import {
  TooltipProvider,
  TooltipTrigger,
  Tooltip as TooltipWrapper,
  TooltipContent,
} from '@/components/ui/tooltip';

interface TooltipButtonProps {
  state: 'default' | 'active' | 'disabled';
  className: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onClick?: () => void;
  tooltipContent?: string;
  showTooltip?: boolean;
  'data-qa-selector'?: string;
}

export const TooltipButton: React.FC<TooltipButtonProps> = ({
  className,
  icon: Icon,
  onClick,
  state,
  tooltipContent = '',
  showTooltip = false,
  'data-qa-selector': dataQaSelector,
}) => {
  const buttonDiv = (
    <div
      role="button"
      onClick={onClick}
      data-qa-selector={dataQaSelector}
      className={clsx(
        'flex h-8 w-8 cursor-pointer items-center justify-center rounded-md transition-all',
        className,
        {
          'text-neutral-0 bg-indigo-500': state === 'active',
          'text-neutral-500 hover:bg-neutral-100': state === 'default',
          'text-[#CED1D6]': state === 'disabled',
        },
      )}
    >
      {Icon && <Icon className="h-4 w-4" />}
    </div>
  );

  return showTooltip ? (
    <TooltipProvider>
      <TooltipWrapper>
        <TooltipTrigger asChild>{buttonDiv}</TooltipTrigger>
        <TooltipContent className='!text-neutral-0 text-body-xs font-["Inter"] text-xs leading-none font-normal'>
          {tooltipContent}
        </TooltipContent>
      </TooltipWrapper>
    </TooltipProvider>
  ) : (
    buttonDiv
  );
};
